module.exports = __webpack_public_path__ + "assets/img/img1.69210a3a.png";